import { Variant } from './utils';
import { getVariantsMeta } from './variant-display-prices';

export const toggleWaitlist = (variant: Variant): void => {
  if (!variant) {
    return;
  }

  const swagTemplate = document.querySelector('.product-template-swag');
  if (!swagTemplate) {
    return;
  }

  const meta = getVariantsMeta('#product-variants-meta');
  const currentVariantMeta = meta[variant.id];
  const waitlistForm = document.querySelector('.pdp-notify-me-form');
  const pageNote = document.querySelector('.product-page-note');
  const optionSelection = document.querySelector('.option-name');
  const ctaButtons = document.querySelector('.product-form__item--submit');
  const quantitySelector = document.querySelector(
    '.product-form__item--quantity'
  );

  if (
    !(waitlistForm instanceof HTMLElement) ||
    !(pageNote instanceof HTMLElement) ||
    !(optionSelection instanceof HTMLElement) ||
    !(ctaButtons instanceof HTMLElement) ||
    !(quantitySelector instanceof HTMLElement)
  ) {
    return;
  }

  if (currentVariantMeta.is_available == 'true') {
    waitlistForm.style.display = 'none';
    ctaButtons.style.display = 'grid';
    quantitySelector.style.display = 'block';
    pageNote.style.display = 'block';
    optionSelection.innerHTML = 'Pattern: ' + currentVariantMeta.option_name;
  } else {
    waitlistForm.style.display = 'block';
    ctaButtons.style.display = 'none';
    quantitySelector.style.display = 'none';
    pageNote.style.display = 'none';
    optionSelection.innerHTML =
      'Pattern: ' + currentVariantMeta.option_name + ' (Out of stock)';
  }
};
